module.exports = __webpack_public_path__ + "img/32.953ca29d.jpg";